import { getCookieValue } from '../../util/helper';

export default function() {
    const body = document.getElementsByTagName('BODY')[0];
    const promotionPopup = document.getElementById('promotionPopup');
    const backdrop = document.getElementById('promotionPopupBackdrop');
    const closeButton = document.getElementById('promotionPopupCloseButton');
    let cookieName = 'dismissed';

    if (promotionPopup != null && closeButton != null) {
        hideModal();

        cookieName = `${promotionPopup.dataset.promotionid}-dismissed`;

        var cookieDismissed = getCookieValue(cookieName);

        if (!cookieDismissed) {
            if (promotionPopup.classList.contains('small')) {
                body.classList.add('modal-small-open');
            } else {
                body.classList.add('modal-large-open');
            }

            promotionPopup.classList.add('show');
            promotionPopup.style.visibility = 'visible';

            if (backdrop != null) {
                backdrop.classList.add('show');
                backdrop.style.visibility = 'visible';
            }
        }
    }

    function hideModal() {
        promotionPopup.style.visibility = 'hidden';
        if (backdrop != null) backdrop.style.visibility = 'hidden';
    }

    function closeModal() {
        hideModal();
        body.classList.remove('modal-large-open');
        body.classList.remove('modal-small-open');
        promotionPopup.classList.remove('show');
        if (backdrop != null) backdrop.classList.remove('show');

        document.cookie = `${cookieName}=true; path=/; max-age=31536000`;
    }

    if (closeButton != null) {
        var anchors = document.getElementById('popupbody').getElementsByTagName('a');
        for (var i = 0; i < anchors.length; i++) {
            anchors[i].addEventListener('click', e => {
                closeModal();
            });
        }

        closeButton.addEventListener('click', e => {
            closeModal();
        });

        document.addEventListener('keydown', e => {
            if (e.key === 'Escape') {
                closeModal();
            }
        });
    }
}
